import React from 'react';

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_iron-site-preview/artifacts/pbc3og4u_Ironvision.png";

const IronVisionLogo = ({ className = '', size = 40 }) => (
  <img
    src={LOGO_URL}
    alt="IronVision logo"
    width={size}
    height={size}
    className={className}
    style={{ width: size, height: size, objectFit: 'contain' }}
  />
);

export default IronVisionLogo;
